import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { getCookieValue } from "app/common/utils/cookie.util";
import { environment } from "environments/environment";
import { BehaviorSubject, first, from, Observable, ReplaySubject, tap } from "rxjs";
import { eProviders, eStatus, iStatus, networkName, networkSettings } from "./web3.config";
import { eNetworkName } from "../contract/contract.config";

// const Web3 = require('web3');
@Injectable({
    providedIn: 'root'
})

export class Web3Service {
    private web3: any;
    accountChanged: BehaviorSubject<boolean> = new BehaviorSubject(false);
    // signStatus: BehaviorSubject<Map<eStatus, any>> = new BehaviorSubject<Map<eStatus, any>>(new Map<eStatus, any>());
    // signStatus: BehaviorSubject<iStatus> = new BehaviorSubject<iStatus>({ status: eStatus.notinit, value: null });//WORK
    private _signStatus: ReplaySubject<Map<string, iStatus>> = new ReplaySubject<Map<string, iStatus>>(1/* new Map<string, iStatus>() */);
    private _signStatusResponse: Map<string, iStatus> = new Map<string, iStatus>();
    private _balanceBnB: ReplaySubject<{ float: number, wei: string, rounded: number }> = new ReplaySubject<{ float: number, wei: string, rounded: number }>(1);
    private networkName: eNetworkName;

    constructor(
        private _httpClient: HttpClient,
    ) { }



    getWeb3() {
        return this.web3;
    }

    setWeb3(web3: any) {
        this.web3 = web3;
    }

    mountWallet(netId: any) {

        let _networkName: eNetworkName = networkName[netId.toString()];
        // this.contractsService.setContractInstancesByNetwork(this.web3, _networkName);
        this.setNetworkName(_networkName);
        this.web3.currentProvider.on('accountsChanged', (accounts) => {
            console.log('accountsChanged', accounts);
            // this.disconnectProvider();
            this.accountChanged.next(true);
        });
        this.web3.currentProvider.on('networkChanged', (accounts) => {
            console.log('networkChanged', accounts);
            // location.reload();
            this.accountChanged.next(true);
        })
    }

    setNetworkName(networkName: eNetworkName) {
        this.networkName = networkName;
        let _allowedNetworks: string[] = environment.allowedNetwork;
        if (!(_allowedNetworks.includes(networkName))) {
            //Wrong Network
            const params = [networkSettings[environment.allowedNetwork[0]]];

            window.ethereum.request({ method: 'wallet_addEthereumChain', params })
                .then(() => console.log('success'))
                .catch((error: Error) => console.log("Error", error.message));
        }
    }


    // switchNetwork() {
    //     const params = [networkSettings[environment.allowedNetwork[0]]];
    //     window.ethereum.request({
    //         method: 'wallet_switchEthereumChain', params
    //     })
    //         .then(() => console.log('Success'))
    //         .catch((error: Error) => location.reload());
    // }

    getNetworkName(): eNetworkName {
        return this.networkName;
    }

    getChainId() {
        // this.web3 = web3;
        return from(this.web3.eth.getChainId());
    }

    isValidAddress(address: string): boolean {
        return this.web3.utils.isAddress(address);
    }

    getAccounts(): Observable<any> {
        return from(this.web3.eth.getAccounts());
    }

    fromWeiFloat(value: string): number {
        return parseFloat(this.web3.utils.fromWei(value));
    }

    toWei(value: number, unit: string = 'ether'): string {
        return this.web3.utils.toWei(value.toString(), unit);
    }
    utf8ToHex(text: string): string {
        return this.web3.utils.utf8ToHex(text);
    }
    getBalanceBnB(wallet: string): Observable<any> {
        return from(this.web3.eth.getBalance(wallet)).pipe(
            tap(/* async */ v => {
                this._balanceBnB.next({
                    float: this.fromWeiFloat(v),
                    wei: v,
                    rounded: parseFloat(this.fromWeiFloat(v).toFixed(2))
                })
            })
        );
    }

    updateBalanceBnB(wallet: string): void {
        this.getBalanceBnB(wallet).pipe(first()).subscribe();
    };

    get balanceBnB$(): Observable<{ float: number, wei: string, rounded: number }> {
        return this._balanceBnB.asObservable();
    }

    get signStatus$(): Observable<Map<string, iStatus>> {
        return this._signStatus.asObservable();
    }

    //LinkWalletPlayFab will be deprecated
    linkWalletPlayFab(provider: eProviders/* , callback: () => void */) {
        console.log('PlayFab 1');
        let msg = this.utf8ToHex('Sign in');
        console.log('msg:' + msg);
        this.getAccounts().subscribe(accounts => {
            console.log('accounts: ' + accounts);
            var from = accounts;
            var params = [msg, from];
            var method = 'personal_sign';
            this.web3.currentProvider.sendAsync({
                method,
                params,
                from
            }, (err: any, result: any) => {
                if (err || result.err) console.log(err || result.err);
                else {
                    let sessionToken = getCookieValue("playfab-session-token");
                    let entityToken = getCookieValue("playfab-entity-token");
                    let playfabId = getCookieValue("playfab-id");
                    let post = { secret: result.result, walletId: accounts, sessionToken: sessionToken, entityToken: entityToken, playfabId: playfabId, provider: provider };
                    this._httpClient.post(environment.apiBaseUrl + 'playfab/linkWallet.php', post).subscribe(
                        (item: any) => {
                            if (item.status == 'OK') console.log('route')/* callback() */;
                            else if (item.status == 'err-wallet-used') console.error('This wallet is already linked to another account, please contact our support!');
                            else console.error('Try again, or contact our team for support-lwp1');
                        }
                    );
                }

            });
        });
    }

    //WORK
    // signMessage(account) {
    //     console.log('start signMessage');
    //     this.signStatus.next({ status: eStatus.pending, value: null });
    //     // this.getAccounts().subscribe(accounts => {
    //     let msg = this.utf8ToHex('Sign in');
    //     var from = account;
    //     var params = [msg, from];
    //     var method = 'personal_sign';
    //     this.web3.currentProvider.sendAsync({
    //         method,
    //         params,
    //         from
    //     }, (err: any, result: any) => {
    //         if (err || result.err) {
    //             this.signStatus.next({ status: eStatus.failed, value: err || result.err });
    //             // console.error(err || result.err);
    //         }
    //         else {
    //             let signatureHash = result.result ? result.result : result;
    //             let res = { result: signatureHash, account: account }
    //             this.signStatus.next({ status: eStatus.success, value: res });
    //             // console.log('result signMessage', result);
    //         }
    //     }
    //     );
    //     console.log('end signMessage');
    //     // });
    // }

    signMessage(account: string, key: string, textToSign: string) {
        console.log('start signMessage');
        this._signStatusResponse.set(key, { status: eStatus.pending, value: null });
        this._signStatus.next(this._signStatusResponse);
        let msg = this.utf8ToHex(textToSign);
        var from = account;
        var params = [msg, from];
        var method = 'personal_sign';
        this.web3.currentProvider.sendAsync({
            method,
            params,
            from
        }, (err: any, result: any) => {
            if (err || result.err) {
                this._signStatusResponse.set(key, { status: eStatus.failed, value: err || result.err });
                this._signStatus.next(this._signStatusResponse);
            }
            else {
                let signatureHash = result.result ? result.result : result;
                let res = { result: signatureHash, account: account }
                this._signStatusResponse.set(key, { status: eStatus.success, value: res });
                this._signStatus.next(this._signStatusResponse);
            }
        }
        );
        console.log('end signMessage');
    }

}